// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"cf21ee6f","246":"020202b8","439":"ed78d08a","498":"f3cc79b6","513":"9e28e4d6","545":"4ecf12a4","651":"1e86c5c5","784":"c7d56779","787":"9e054621","863":"701ba3fb"}[chunkId] + ".chunk.js";
};